import { DayOfWeekType } from 'lib/daysOfWeek'
import { Dispatch, SetStateAction, useEffect } from 'react'
import { getBusinessTimeOnDay, getOpenTimeOnDay } from 'lib/businessHour'
import { OpenTimeType, BusinessTimeType, HandleBusinessTimeType } from 'types/store'
import { INITIAL_HANDLE_BUSINESS_TIME } from 'constants/businessTime'

const useFormatBusinessTimes = (
  daysOfWeek: DayOfWeekType[],
  openTime: OpenTimeType | undefined,
  orderStartTime: BusinessTimeType | undefined,
  lastOrderTime: BusinessTimeType | undefined,
  lastPickupTime: BusinessTimeType | undefined,
  relativePickupableTime: BusinessTimeType | undefined,
  setBusinessTimes: Dispatch<SetStateAction<HandleBusinessTimeType[]>>
) => {
  return useEffect(() => {
    if (!openTime || !orderStartTime || !lastOrderTime || !lastPickupTime) return
    const businessTimes: HandleBusinessTimeType[] = []
    for (let i = 0; i < daysOfWeek.length; i = (i + 1) | 0) {
      const dayOfWeek = daysOfWeek[i]
      const businessTimeOnDay = {
        open_time: getOpenTimeOnDay(dayOfWeek, openTime),
        order_start_time: getBusinessTimeOnDay(dayOfWeek, orderStartTime),
        last_order_time: getBusinessTimeOnDay(dayOfWeek, lastOrderTime),
        last_pickup_time: getBusinessTimeOnDay(dayOfWeek, lastPickupTime),
        relative_pickupable_time: getBusinessTimeOnDay(dayOfWeek, relativePickupableTime),
      }
      // 定休日
      if (Object.values(businessTimeOnDay).some((time) => time === null)) continue
      const index = businessTimes.findIndex((businessTime) => {
        return (
          businessTime.open_time === businessTimeOnDay.open_time &&
          businessTime.order_start_time === businessTimeOnDay.order_start_time &&
          businessTime.order_start_time === businessTimeOnDay.order_start_time &&
          businessTime.last_pickup_time === businessTimeOnDay.last_pickup_time &&
          businessTime.relative_pickupable_time === businessTimeOnDay.relative_pickupable_time
        )
      })
      // 4種類の時刻が完全に一致しなければ追加
      if (index === -1) {
        businessTimes.push({
          days_of_week: [dayOfWeek],
          open_time: businessTimeOnDay.open_time as string,
          order_start_time: businessTimeOnDay.order_start_time as string,
          last_order_time: businessTimeOnDay.last_order_time as string,
          last_pickup_time: businessTimeOnDay.last_pickup_time as string,
          relative_pickupable_time: businessTimeOnDay.relative_pickupable_time as string,
        })
      } else {
        businessTimes[index].days_of_week.push(dayOfWeek)
      }
    }
    if (businessTimes.length === 0) {
      setBusinessTimes([INITIAL_HANDLE_BUSINESS_TIME])
    } else {
      setBusinessTimes([...businessTimes])
    }
  }, [openTime, orderStartTime, lastOrderTime, lastPickupTime, relativePickupableTime])
}

export default useFormatBusinessTimes
